module.exports = require("rxjs/Subscription");


//////////////////
// WEBPACK FOOTER
// external "rxjs/Subscription"
// module id = 1004
// module chunks = 0